import React, { useEffect } from 'react';
import { Card, Col, Form, Row, Button } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { useFormContext } from 'react-hook-form';
import { useState } from 'react';
import { useNavigate, useParams } from "react-router-dom";
import DatePicker from "react-datepicker";
import LoaFormGrid from './LoaFormGrid';
import Spinner from 'react-bootstrap/Spinner';
import ThemedSelect from 'components/commonbreadcrumb/ThemedSelect';
import { use } from 'react';
import axios from 'helpers/api';

const LoaForm = ({ data }) => {
    // State
    const {id} = useParams();
    const [formData, setFormData] = useState({
        docUpload: '',
        docDescription: '',
        hcp: '',
        reportformat: '1',
        docDesignation : ''
    });
    const [tableData, setTableData] = useState(null);
    const [departureDate, setDepartureDate] = useState(null);
    const [returnDate, setReturnDate] = useState(null);
    const [spinner, showSpinner] = useState(false);
    const [hcpoptions, setHcpOptions] = useState([]);
    const [childTableData, setChildTableData] = useState(null);
    const [errors, setErrors] = useState({
        departureDate: false,
        returnDate: false,
        // reportformat: true
      });
    const { programId } = useParams();
    const navigate = useNavigate();

    // Handler
    const handleSubmit = async (e) => {
        e.preventDefault();
        const newErrors = {
            departureDate: !departureDate,
            returnDate: !returnDate,
            // reportformat: !formData.reportformat,
            docDesignation: !formData.docDesignation
        };

        setErrors(newErrors);

        const hasErrors = Object.values(newErrors).some(error => error);
        if (hasErrors) return;
        showSpinner(true);
      
        // Format dates to 'YYYY-MM-DD HH:mm:ss'
        const formatDateTime = (date) => {
          if (!date) return null;
          const pad = (n) => (n < 10 ? '0' + n : n);
          return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:00`;
        };
      
        const payload = {
          patient_id: id,
          departure_datetime: formatDateTime(departureDate),
          return_datetime: formatDateTime(returnDate),
          hcp_order_format: parseInt(formData.reportformat, 10),
          designation : formData.docDesignation,
          hcp_id : formData.hcp,
        };
      
        // if (formData.hcp) {
        //   payload.hcp = formData.hcp;
        // }
        setChildTableData(payload);
        console.log("Final Payload:", payload);


        let tokenStr = localStorage.getItem("accessToken");
        let pelmedsMedSheetUrl = `${process.env.REACT_APP_SERVER_URL}` + "/reports/loa";
      
        const { data } = await axios.post(pelmedsMedSheetUrl, payload, { headers: { 'Authorization': `Bearer ${tokenStr}` } });
        if (data.status) {
            setTableData(data.validPrescriptions);
            showSpinner(false);
        }
      };
      

    const handleFieldChange = e => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };
    const handleHcpFieldChange = e => {
        setFormData({
            ...formData,
            'hcp': e.value
        });
    };

    useEffect(() => {
        const uniqueDoctors = new Set();
        let doctorOptions = [];
        data?.prescriptions.forEach((prescription) => {
            const doctorFullName = `${prescription.doctor_firstname} ${prescription.doctor_lastname}`;
            const doctorId = prescription.doctor_id;
            if (!uniqueDoctors.has(doctorId)) {
                uniqueDoctors.add(doctorId);
                doctorOptions.push({
                    key: doctorFullName,
                    value: doctorId,
                });
            }
        });
        setHcpOptions(doctorOptions);
    }, [data.prescriptions]);

    return (
        <Form onSubmit={handleSubmit}>
            <Row>
                <Col>
                    <Form.Group className="mb-3">
                        <Form.Label className='required'>Departure</Form.Label>
                        <DatePicker
                            popperPlacement="bottom-start"
                            selected={departureDate}
                            onChange={(date) => setDepartureDate(date)}
                            formatWeekDay={(day) => day.slice(0, 3)}
                            className="form-control"
                            placeholderText="Select Date & Time"
                            timeIntervals={15}
                            dateFormat="MM/dd/yy h:mm aa"
                            showTimeSelect
                            fixedHeight
                            minDate={new Date()}
                        />
                         {errors.departureDate && <div className="invalid-feedback">Departure date is required</div>}
                    </Form.Group>
                </Col>
                <Col>
                    <Form.Group className="mb-3">
                        <Form.Label className='required'>Return</Form.Label>
                        <DatePicker
                            popperPlacement='bottom-start'
                            selected={returnDate}
                            onChange={(date) => setReturnDate(date)}
                            formatWeekDay={day => day.slice(0, 3)}
                            className='form-control'
                            placeholderText="Select Date & Time"
                            timeIntervals={15}
                            dateFormat="MM/dd/yy h:mm aa"
                            showTimeSelect
                            fixedHeight
                            minDate={new Date()}
                        />
                        {errors.returnDate && <div className="invalid-feedback">Return date is required</div>}
                    </Form.Group>
                </Col>
            </Row>
            <Row>
                <Col>
                    <Form.Label className='required'>Destination</Form.Label>
                    <Form.Control
                        placeholder="Enter Destination"
                        onChange={handleFieldChange}
                        name="docDesignation"
                    />
                    {errors.docDesignation && <div className="invalid-feedback">Destination is required</div>}
                </Col>
            </Row>
            <Row>
                <Col></Col>
                <Col>
                    <Form.Group>
                        {spinner && (
                            <Button variant="primary" disabled className="mt-3 w-100">
                                <Spinner
                                    as="span"
                                    animation="grow"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                />
                                <span className="p-2" style={{ "verticalAlign": "3px" }}>Fetching...</span>
                            </Button>
                        )}
                        {!spinner && (
                            <Button
                                type="submit"
                                color="primary"
                                className="mt-3 w-100">
                                Calculate
                            </Button>
                        )}
                    </Form.Group>
                </Col>
            </Row>
            <Row>
                <Col className="mt-3">
                    {tableData != null && <LoaFormGrid childTableData = {childTableData} data = {tableData} />}
                </Col>
            </Row>
        </Form>
    );
};

LoaForm.propTypes = {
    layout: PropTypes.string,
    hasLabel: PropTypes.bool
};

LoaForm.defaultProps = {
    layout: 'simple',
    hasLabel: false
};

export default LoaForm;

